import { ConfigurationService } from '../../../shared/services/configuration.service'
import { Observable } from 'rxjs'
import { Component, OnInit } from '@angular/core'
import { configurationOptionSelectors } from '../../../features/configuration-option/configuration-option.selectors'
import { filter, map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { Store } from '@ngrx/store'
import { AppState } from '../../../core/core.state'

@Component({
  selector: 'primary-navbar-non-logged-in',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class PrimaryNavbarNonLoggedInComponent implements OnInit {
  public primaryLogoUrl$: Observable<string>

  constructor(
    private store: Store<AppState>,
    public configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.logoUrl()
  }

  private logoUrl() {
    this.primaryLogoUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'primary_logo_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) =>
          configOption?.value.length
            ? `${environment.staticAssetBaseUrl}${configOption?.value}`
            : ''
        )
      )
  }
}
